import type { AuthSession, MediaDownload } from "./types";
import { authenticatedFetch } from "./auth";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string | undefined;

export async function getRemoteMessageMedia(
  conversationId: string,
  messageId: string,
  session: AuthSession,
  sentAt?: string,
): Promise<MediaDownload> {
  if (!API_BASE_URL) throw new Error("API_NOT_CONFIGURED");
  const query = sentAt ? `?sentAt=${encodeURIComponent(sentAt)}` : "";
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 12_000);
  try {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/bridge/media/${encodeURIComponent(conversationId)}/${encodeURIComponent(messageId)}${query}`,
      session,
      { signal: controller.signal },
    );
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      const code = typeof body?.error === "string" ? body.error : `HTTP_${response.status}`;
      throw new Error(code);
    }
    return body as MediaDownload;
  } finally {
    window.clearTimeout(timeout);
  }
}
